import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'

import {NumbersCardContent, DummyImage} from './styles'

const propTypes = {
  cardDetails: PropTypes.shape({
    numberLabel: PropTypes.string.isRequired,
    description: PropTypes.string,
    image: PropTypes.string,
  }),
  isTextSm: PropTypes.bool,
  isImgLg: PropTypes.bool,
  isCentered: PropTypes.bool,
  colorHex: PropTypes.string,
}

const defaultProps = {
  cardDetails: {
    numberLabel: '',
    description: '',
    image: '',
  },
  isTextSm: false,
  isImgLg: false,
  isCentered: false,
  colorHex: undefined,
}

export type NumbersCardProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const NumbersCard = React.forwardRef<HTMLDivElement, NumbersCardProps>(
  ({cardDetails, isTextSm, isImgLg, isCentered, colorHex}, ref) => (
    <NumbersCardContent
      isTextSm={isTextSm}
      isImgLg={isImgLg}
      isCentered={isCentered}
      colorHex={colorHex}
      ref={ref}
    >
      {cardDetails?.image ? (
        <img src={cardDetails?.image || ''} alt={cardDetails?.description || ''} />
      ) : (
        <DummyImage isImgLg={isImgLg} />
      )}
      <h2>{cardDetails?.numberLabel}</h2>
      <span>{cardDetails?.description}</span>
    </NumbersCardContent>
  )
)

NumbersCard.propTypes = propTypes

NumbersCard.defaultProps = defaultProps

export default NumbersCard
